import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import pageService from "./pageService";

export const getPage = createAsyncThunk(
    "page/get",
    async (params, thunkAPI) => {
        try {
            return await pageService.get(params);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

const initialState = {
    page: "",
    isError: false,
    isLoading: false,
    isSuccess: false,
    message: "",
};
export const pageSlice = createSlice({
    name: "page",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPage.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPage.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.page = action.payload.page;
            })
            .addCase(getPage.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
    },
});
export default pageSlice.reducer;
